import * as api from '@/api'
import { pbError } from '@/pb'
import { useInputState } from '@/utils'
import { Button, Paper, TextField, Typography } from '@mui/material'
import { useState } from 'react'

export default function Settings() {

  const [apiEndpoint, set_apiEndpoint] = useInputState('')
  const [apiKey, set_apiKey] = useInputState('')
  const [apiUser, set_apiUser] = useInputState('')
  const [apiPass, set_apiPass] = useInputState('')

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const handleIntegrationConfigSaveClick = () => {
    setLoading(true)
    setError('')
    api.integrationConfig({ apiEndpoint, apiKey, apiUser, apiPass }).then(() => {
      setLoading(false)
      setError('ok')
    }).catch(e => {
      setLoading(false)
      setError(pbError(e))
    })
  }

  return <>
    <Paper style={{ display: 'flex', flexDirection: 'column', gap: '1em', padding: '1em' }}>
      <Typography variant="h5">Настройки 1С авторизации</Typography>
      <TextField label="API Endpoint" value={apiEndpoint} onChange={set_apiEndpoint} />
      <TextField label="API Key" type="password" value={apiKey} onChange={set_apiKey} />
      <TextField label="API User" value={apiUser} onChange={set_apiUser} />
      <TextField label="API Password" type="password" value={apiPass} onChange={set_apiPass} />
      <Button loading={loading} variant="contained" onClick={handleIntegrationConfigSaveClick}>Сохранить</Button>
      {!!error && <code>{error}</code>}
    </Paper>
  </>
}